
class ShareButtonLinks {
  constructor(config = {}){
    const {
      link
    } = config;
    // Replace placeholder in share-buttons
    let shareButtons = document.querySelectorAll('.ns-share-buttons__link');
    
    shareButtons.forEach(function(item, index){
      let href = item.href.replace('__URL__', link);
      item.href = href;
    });
  }
} export default ShareButtonLinks;
